import React, { memo } from 'react';

import { Skeleton, Typography } from '@mui/material';
import { WithLoadingPropTypes } from 'hocs/withLoading';

import { ValueStub } from 'constants/data';

const getSkeletonStyles = (variant, skeletonWidth) => ({
  height: ({ typography }) => typography[variant].lineHeight,
  width: skeletonWidth,
});

const TypographyWithSkeleton = ({ children, isLoading, skeletonWidth, ...props }) => (
  <>
    {isLoading ? (
      <Skeleton sx={getSkeletonStyles(props.variant, skeletonWidth)} variant="text" />
    ) : (
      <Typography {...props} variant="regular14">
        {children ?? ValueStub.COMMON}
      </Typography>
    )}
  </>
);

TypographyWithSkeleton.propTypes = {
  ...WithLoadingPropTypes,
};

export default memo(TypographyWithSkeleton);
